//* CSS colors
const getCSSColor = (color) => {
  return getComputedStyle(document.documentElement).getPropertyValue(color);
};

const white = getCSSColor('--white');
const offWhite = getCSSColor('--offWhite');
const darkWhite = getCSSColor('--darkWhite');
const greyThemeDark = getCSSColor('--grey-themeDark');
const blueGrey = getCSSColor('--blueGrey');
const grey = getCSSColor('--grey');
const orange = getCSSColor('--orange');

export const chartDataOne = () => {
  console.log('this is chart data one');
};

// @ dark: pass in $vuetify.theme.dark or other option
export const baseDoughnutBGColor = (dark = false) => {
  return dark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)';
};

// @ dark: pass in $vuetify.theme.dark or other option
export const baseDoughnutOptions = (dark = false) => {
  let fontColor = greyThemeDark || '#424242';
  if (dark) {
    fontColor = white || '#FFFFFF';
  }

  return {
    segmentShowStroke: true,
    responsive: true,
    maintainAspectRatio: true,
    // rotation: -1.0 * Math.PI,
    animation: {
      duration: 1000,
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        labels: {
          color: fontColor,
        },
      },
      title: {
        display: true,
        color: dark ? '#ffffff' : '#424242',
        font: {
          size: 20,
        },
      },
      tooltip: {
        displayColors: false,
        titleFontStyle: 'normal',
        titleFontSize: 18,
        cornerRadius: 3,
        bodyFontFamily: `'Proxima Nova', sans-serif`,
        bodyFontColor: '#EFEFEF',
        bodyFontSize: 14,
        xPadding: 14,
        yPadding: 14,
        mode: 'index',
        intersect: false,
        callbacks: {
          label(tooltipItem) {
            const { formattedValue } = tooltipItem;
            return `${formattedValue ? formattedValue.toLocaleString() : ''}`;
          },
        },
      },
    },
  };
  // let fontColor = greyThemeDark || '#424242';
  // if (dark) {
  //   fontColor = white || '#FFFFFF';
  // }

  // return {
  //   segmentShowStroke: true,
  //   percentageInnerCutout: 0,
  //   animationSteps: 100,
  //   responsive: true,
  //   maintainAspectRatio: true,
  //   showScale: true,
  //   cutoutPercentage: 60,
  //   rotation: -1.0 * Math.PI,
  //   legend: {
  //     labels: {
  //       fontColor,
  //     },
  //   },
  //   animation: {
  //     duration: 0,
  //   },
  // };
};

// @ dark: pass in $vuetify.theme.dark or other option
export const basePieOptions = (dark = false) => {
  let fontColor = greyThemeDark || '#424242';
  if (dark) {
    fontColor = white || '#FFFFFF';
  }

  return {
    responsive: true,
    maintainAspectRatio: true,
    animation: {
      animateScale: true,
      duration: 1000,
    },
    plugins: {
      datalabels: {
        display: false,
      },
      title: {
        display: true,
        color: dark ? '#ffffff' : '#424242',
        font: {
          size: 20,
        },
      },
      legend: {
        labels: {
          color: fontColor,
          position: 'top',
        },
      },
      tooltip: {
        displayColors: false,
        titleFontStyle: 'normal',
        titleFontSize: 18,
        cornerRadius: 3,
        bodyFontFamily: `'Proxima Nova', sans-serif`,
        bodyFontColor: '#EFEFEF',
        bodyFontSize: 14,
        padding: 14,
        xPadding: 14,
        yPadding: 14,
        mode: 'index',
        intersect: false,
        titleFont: {
          style: 'normal',
          size: 18,
        },
        bodyColor: '#EFEFEF',
        bodyFont: {
          family: `'Proxima Nova', sans-serif`,
          size: 14,
        },
        callbacks: {
          label(tooltipItem) {
            const { formattedValue } = tooltipItem;
            return `${formattedValue ? formattedValue.toLocaleString() : ''}`;
          },
        },
      },
    },
  };
};

// @ dark: pass in $vuetify.theme.dark or other option
// @ tooltipOptions: pass in options for custom tooltips. i.e. multiple tooltips, etc. Set custom to true.
// @ tooltipOptions include: custom, tooltipOne, tooltipTwo, displayColors
export const baseChartOptions = (dark = false, tooltipOptions) => {
  const {
    custom = false,
    tooltipOne = '',
    tooltipTwo = '',
    displayColors = false,
  } = tooltipOptions ?? {};
  let delayed;
  let fontColor = greyThemeDark || '#424242';
  if (dark) {
    fontColor = white || '#FFFFFF';
  }

  return {
    responsive: true,
    maintainAspectRatio: false,
    showScale: true,
    animation: {
      duration: 750,
      onComplete: () => {
        delayed = true;
      },
      delay: (context) => {
        let delay = 0;
        if (context.type === 'data' && context.mode === 'default' && !delayed) {
          // delay = context.dataIndex * 300 + context.datasetIndex * 100;
          delay = context.dataIndex * 150 + context.datasetIndex * 100;
        }
        return delay;
      },
    },
    scales: {
      x: {
        ticks: {
          color: fontColor,
        },
        gridLines: {
          display: true,
          color: offWhite || '#EFEFEF',
        },
      },
      y: {
        ticks: {
          beginAtZero: false,
          color: fontColor,
        },
        gridLines: {
          display: true,
          color: offWhite || '#EFEFEF',
        },
        categoryPercentage: 1,
        barPercentage: 0.4,
      },
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
        color: dark ? '#ffffff' : '#424242',
        font: {
          size: 20,
        },
      },
      tooltip: {
        displayColors,
        cornerRadius: 3,
        padding: 14,
        mode: 'index',
        intersect: false,
        titleFont: {
          style: 'normal',
          size: 18,
        },
        bodyColor: offWhite || '#EFEFEF',
        bodyFont: {
          family: `'Proxima Nova', sans-serif`,
          size: 14,
        },
        callbacks: {
          label: (tooltipItem) => {
            const { formattedValue } = tooltipItem;

            if (custom) {
              const tooltipValue = tooltipItem.datasetIndex === 0 ? tooltipOne : tooltipTwo;
              return `⛳ ${
                formattedValue ? formattedValue.toLocaleString() : ''
              } - ${tooltipValue}`;
            }
            return `⛳ ${formattedValue ? formattedValue.toLocaleString() : ''}${
              tooltipOne ? ` - ${tooltipOne}` : ''
            }`;
          },
        },
      },
    },
  };
};

// @ dark: pass in $vuetify.theme.dark or other option
// @ tooltipOptions: pass in options for custom tooltips. i.e. multiple tooltips, etc. Set custom to true.
export const baseLineChartOptions = (dark = false, tooltipOptions) => {
  const { custom = false, tooltipOne = '', tooltipTwo = '', isPar = false } = tooltipOptions ?? {};
  let delayed;
  let fontColor = greyThemeDark || '#424242';
  if (dark) {
    fontColor = white || '#FFFFFF';
  }

  return {
    responsive: true,
    animation: {
      duration: 750,
      onComplete: () => {
        delayed = true;
      },
      delay: (context) => {
        let delay = 0;
        if (context.type === 'data' && context.mode === 'default' && !delayed) {
          // delay = context.dataIndex * 300 + context.datasetIndex * 100;
          delay = context.dataIndex * 150 + context.datasetIndex * 100;
        }
        return delay;
      },
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        labels: {
          color: fontColor,
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        cornerRadius: 3,
        padding: 14,
        titleFont: {
          style: 'normal',
          size: 18,
        },
        bodyColor: offWhite || '#EFEFEF',
        bodyFont: {
          family: `'Proxima Nova', sans-serif`,
          size: 14,
        },
        callbacks: {
          label(tooltipItem) {
            const { label } = tooltipItem.dataset;
            const { formattedValue } = tooltipItem;
            const yards = formattedValue * 1.0 || 0.0;
            if (custom) {
              return `${label}: ${formattedValue}`;
            }
            if (isPar) {
              const par = formattedValue * 1.0 || 0.0;
              return `${label}: ${par.toFixed(0)}`;
            }
            return `${label}: ${yards.toFixed(0)}yds`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: fontColor,
        },
      },
      y: {
        ticks: {
          color: fontColor,
          stepSize: 2500,
          callback: (value, index, values) => {
            return value > 1000 ? `${value / 1000}k` : value;
          },
        },
      },
    },
    // hover: {
    //   mode: 'index',
    //   intersect: false,
    // },
  };
};

// @ data: pass in array of data to convert
export const baseChartData = (data) => {
  if (!Array.isArray(data)) {
    return {};
  }

  const chartData = data;
  const labels = chartData?.map((item) => {
    return item;
  });
  const chartDataSet = chartData?.map((item) => {
    return item;
  });

  return {
    labels,
    borderSkipped: 'bottom',
    //* multi-dataset
    // datasets: [
    //   /* Outer data starts */
    //   {
    //     data: dataRounds,
    //     backgroundColor: [
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //       '#BA2127',
    //     ],
    //   },
    //   /* Outer data ends */
    //   /* Inner data starts */
    //   {
    //     data: dataShots,
    //     backgroundColor: [
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //       '#5995c7',
    //     ],
    //   },
    //   /* Inner data ends */
    // ],
    //* single dataset
    datasets: [
      {
        data: chartDataSet ?? [],
        backgroundColor: '#ECC75F',
        hoverBackgroundColor: '#BC9F4C',
        pointHoverRadius: 4,
        pointHitRadius: 10,
        pointHoverBorderWidth: 1,
      },
    ],
  };
};

export const CHART_COLORS = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(75, 192, 192)',
  blue: 'rgb(54, 162, 235)',
  blueInfo: 'rgb(19, 73, 191)',
  purple: 'rgb(153, 102, 255)',
  // grey: 'rgb(201, 203, 207)',
  grey: 'rgb(185, 185, 185)',
  white: 'rgb(255, 255, 255)',
  black: 'rgb(51, 51, 51)',
  tgRed: 'rgb(228, 62, 48)',
  tgRedOP: 'rgba(228, 62, 48, 0.1)',
  tgLightBlue: 'rgb(0, 191, 221)',
  tgLightBlueOP: 'rgba(0, 191, 221, 0.1)',
  tgLightBlueHover: 'rgb(0, 152, 205)',
  tgDarkBlue: 'rgb(30, 68, 136)',
  tgDarkBlueHover: 'rgb(0, 124, 187)',
  tgGreen: 'rgb(123, 194, 78)',
  tgGreenOP: 'rgba(123, 194, 78, 0.1)',
  tgLightGreen: 'rgb(208, 221, 187)',
  tgDarkGreen: 'rgb(35, 93, 57)',
  tgOrange: 'rgb(243, 177, 32)',
  tgOrangeOP: 'rgba(243, 177, 32, 0.1)',
  tgDarkOrange: 'rgb(223, 107, 42)',
  tgPurple: 'rgb(83, 84, 135)',
  tgPurpleOP: 'rgba(83, 84, 135, 0.1)',
};
